const GLOBALS = {
  MEMBERSHIP_STATUS_ACTIVE_ENGAGED: "Active Engaged",
  MEMBERSHIP_STATUS_ACTIVE_UNENGAGED: "Active Unengaged",
  ACTIVE_STATUS: ["Active Engaged", "Active Unengaged"],
}

module.exports = GLOBALS
